import { render, staticRenderFns } from "./SubMainMenu.vue?vue&type=template&id=4609aa8a&scoped=true"
import script from "./SubMainMenu.vue?vue&type=script&lang=js"
export * from "./SubMainMenu.vue?vue&type=script&lang=js"
import style0 from "./SubMainMenu.vue?vue&type=style&index=0&id=4609aa8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4609aa8a",
  null
  
)

export default component.exports